import {Box, HStack, Text} from '@tempo/core';
import Thumbnail from '@components/Thumbnail';
import {ContentType} from '@deezer/next/services/types/contentType';
import HighlightedText from '@components/Navigation/SearchBar/HighlightedText';
import {NavLink} from '@tempo/nextjs';
import React, {useMemo} from 'react';
import type {ArtistSearchResult} from '@deezer/next/services/api/Starmania/requests/search/types';
import SearchMode from '@deezer/next/shared/utils/SearchMode';
import {Routes} from '@constants/routes';

type ArtistSearchResultItemProps = {
	query: string;
	artist: ArtistSearchResult;
	searchMode: SearchMode;
};

const ArtistSearchResultItem = ({
	query,
	artist,
	searchMode,
}: ArtistSearchResultItemProps) => {
	const redirectUrl = useMemo(() => {
		if (searchMode === SearchMode.editArtist) {
			return `${Routes.EDIT_ARTIST}/${artist.id}`;
		}
		return artist.redirectUrl + `?deezerId=${artist.id}`;
	}, [searchMode, artist.id, artist.redirectUrl]);

	return (
		<NavLink href={redirectUrl}>
			<HStack spacing={3}>
				<Thumbnail
					id={String(artist.id)}
					picture={artist.picture}
					type={ContentType.Artist}
					rounded={true}
					width={'62px'}
					height={'62px'}
					coverLink={false}
				/>
				<Box>
					<Text
						as="h4"
						variant="body.default.regular"
						data-testid="search-item-title"
						noOfLines={1}
					>
						<HighlightedText query={query}>{artist.name}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						color="text.neutral.secondary.default"
					>
						Deezer ID:{' '}
						<HighlightedText query={query}>{String(artist.id)}</HighlightedText>
					</Text>
				</Box>
			</HStack>
		</NavLink>
	);
};

export default ArtistSearchResultItem;
